import * as actionTypes from 'constants/ActionTypes';

const listGazetters = (state = {
    originalList: [],
    filteredList: [],
}, action) => {
    switch (action.type) {
        case actionTypes.LIST_GAZETTERS.REQUEST: {
            return { ...state }
        }
        case actionTypes.LIST_GAZETTERS.SUCCESS:
            return {
                filteredList: action.data,
            };
        case actionTypes.LIST_GAZETTERS.FAILURE:
            return { ...state };
        default:
            return state;
    }
};

export default listGazetters;



// WEBPACK FOOTER //
// ./app/reducers/listGazetters.js